const filter = [
  {
    service: {
      folder: 'bibliotecas',
      file: 'Bibliotecas',
      relationship: ''
    },
    listLabel: 'biblioteca',
    label: 'Biblioteca',
    itemValue: 'id',
    itemText: 'apelido',
    id: 'includes[leitor.biblioteca][id]'
  }
  // {
  //   service: {
  //     folder: 'obras',
  //     file: 'Obras',
  //     relationship: ''
  //   },
  //   listLabel: 'obra',
  //   label: 'Obra',
  //   itemValue: 'id',
  //   itemText: 'titulo',
  //   id: 'obra_id'
  // }
]
export default filter
